import * as SalesforceAuditTypes from './salesforceAudit.types'

import ApiManager from '../Api.manager'
import { FilterTypes } from '../../enum/Filter.enum'
import HttpConstants from '../../constants/HttpConstants'
import UrlConstants from '../../constants/UrlConstants'
import { getFiltersForApi } from '../../utils/FilterUtils'

export const makeApiCallToInstance = (instanceUrl: string): any => {
  return new Promise((resolve, reject) => {
    fetch(instanceUrl, { mode: 'no-cors' })
      .then(() => resolve(true))
      .catch((err) => reject(err))
  })

  return true
}

interface SalesforcePaginatedResponse {
  data: any[]
  pagination: {
    skip: number
    take: number
    totalCount: number
  }
}

export const connectToSalesforceInstance = (
  code: string,
  headers: object
): any => {
  return new Promise((resolve, reject) => {
    const usecase = UrlConstants.CONNECT_TO_SALESFORCE.USECASE
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.POST_METHOD,
      {
        code,
        headers
      }
    )
      .then((response) => {
        if (response.status === 201) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const downloadSalesforceReport = async (payload: {
  salesforceAuditId: string
  profileUserLicenseId?: string
  isActive?: any
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_REPORT.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.error(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforceApexClassesReport = async (payload: {
  salesforceAuditId: string
  isActive?: any
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_APEX_CLASSES_REPORT.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        // FIX: CHECK BUSINESS STATUS, NOT HTTP STATUS
        if (response.data?.status === 'SUCCESS') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforceApexTriggersReport = async (payload: {
  salesforceAuditId: string
  isActive?: any
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_APEX_TRIGGERS_REPORT.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        // FIX: CHECK BUSINESS STATUS, NOT HTTP STATUS
        if (response.data?.status === 'SUCCESS') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforcePermissionSetsReport = async (payload: {
  salesforceAuditId: string
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase =
    UrlConstants.DOWNLOAD_SALESFORCE_PERMISSION_SETS_REPORT.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        // FIX: CHECK BUSINESS STATUS, NOT HTTP STATUS
        if (response.data?.status === 'SUCCESS') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforceProfilesReport = async (payload: {
  salesforceAuditId: string
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_PROFILES.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        // FIX: CHECK BUSINESS STATUS, NOT HTTP STATUS
        if (response.data?.status === 'SUCCESS') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforceRolesReport = async (payload: {
  salesforceAuditId: string
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_ROLES.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        // FIX: CHECK BUSINESS STATUS, NOT HTTP STATUS
        if (response.data?.status === 'SUCCESS') {
          resolve(response.data)
        } else {
          reject(response.data)
        }
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const downloadSalesforcePSLReport = async (payload: {
  salesforceAuditId: string
  permissionSetLicenseId?: string
  isActive?: any
}): Promise<any> => {
  const filters = getFiltersForApi(FilterTypes.SALESFORCE_AUDIT, payload)
  const usecase = UrlConstants.DOWNLOAD_SALESFORCE_PSL_REPORT.USECASE

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.error(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data?.error?.message || 'Download failed'
        )
      })
  })
}

export const checkInstanceAvailability = (instanceUrl: string): any => {
  const usecase = UrlConstants.CHECK_INSTANCE_AVAILABILITY.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      { instanceUrl }
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforceAuditDataAPI = (): any => {
  const usecase = UrlConstants.GET_SALESFORCE_AUDIT_DATA.USECASE
  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      {}
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const updateSalesforceAuditDetails = (
  payload: SalesforceAuditTypes.updateSalesforceAuditDetails
) => {
  return new Promise((resolve, reject) => {
    const usecase = UrlConstants.UPDATE_SALESFORCE_AUDIT_DETAILS.USECASE
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.PATCH_METHOD,
      payload
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else {
          throw response
        }
      })
      .catch((error) => {
        console.log(`Error in ${usecase}:`, error)
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalasForceUserPaginatedData = async (payload: {
  $salesforceAuditId: string
  profileUserLicenseId?: string
  profilePermissionSetLicenseId?: string
  page?: number
  size?: number
  isActive?: any
}): Promise<SalesforcePaginatedResponse> => {
  const usecase = UrlConstants.SALESFORCE_USERS_PAGINATED.USECASE

  try {
    const response = await ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )

    if (response.status === 200) {
      return response.data
    } else {
      throw new Error(`API Error: ${response.status}`)
    }
  } catch (error: any) {
    console.error(`Error in ${usecase}:`, error)
    throw new Error(error?.data?.message || 'Unknown error occurred')
  }
}

export const getSalesforceUserPSLPaginatedData = async (payload: {
  $salesforceAuditId: string
  salesforceUserId?: string
  permissionSetLicenseId?: string
  page?: number
  size?: number
  isActive?: any
}): Promise<any> => {
  const usecase = UrlConstants.SALESFORCE_USERS_PSL_PAGINATED.USECASE

  try {
    const response = await ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      payload
    )

    if (response.status === 200) {
      return response.data
    } else {
      throw new Error(`API Error: ${response.status}`)
    }
  } catch (error: any) {
    console.error(`Error in ${usecase}:`, error)
    throw new Error(error?.data?.message || 'Unknown error occurred')
  }
}

export const getSalesforceLimitUsage = (payload: {
  id: string
  salesforceApiName: string
  paramsWithDateRange: {
    'created-from': string
    'created-to': string
    'time-zone': string
  }
}): any => {
  const usecase = UrlConstants.GET_SALESFORCE_LIMIT_USAGE.USECASE

  const filters = {
    $id: payload.id,
    'salesforce-api-name': payload.salesforceApiName,
    ...getFiltersForApi(
      FilterTypes.SALESFORCE_AUDIT,
      payload.paramsWithDateRange
    )
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforceProfiles = (payload: { id: string }): any => {
  const usecase = UrlConstants.GET_SALESFORCE_PROFILES.USECASE

  const filters = {
    $id: payload.id
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforcePermissionSets = (payload: {
  id: string
  page?: number
  size?: number
}): any => {
  const usecase = UrlConstants.GET_SALESFORCE_PERMISSION_SETS.USECASE

  const filters = {
    $id: payload.id,
    page: payload.page,
    size: payload.size
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforceRoles = (payload: { id: string }): any => {
  const usecase = UrlConstants.GET_SALESFORCE_ROLES.USECASE

  const filters = {
    $id: payload.id
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforceApexClasses = (payload: { id: string }): any => {
  const usecase = UrlConstants.GET_SALESFORCE_APEX_CLASSES.USECASE

  const filters = {
    $id: payload.id
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}

export const getSalesforceApexTriggers = (payload: { id: string }): any => {
  const usecase = UrlConstants.GET_SALESFORCE_APEX_TRIGGERS.USECASE

  const filters = {
    $id: payload.id
  }

  return new Promise((resolve, reject) => {
    ApiManager.makeApiCallWithAuthentication(
      usecase,
      HttpConstants.GET_METHOD,
      filters
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data)
        } else throw response
      })
      .catch((error) => {
        reject(
          [401, 403].includes(error.status)
            ? error.data.message
            : error.data.error.message
        )
      })
  })
}
